import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import errorImage from '../../assets/img/error-img.svg';
import errorImageUB from '../../assets/img/error-img-ub.svg';
import { getColor } from '../../core/themev3';

const siteId = process.env.REACT_APP_BUILD_SITE;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ isDesktop }) => (isDesktop ? '90vh' : '100vh')};
  width: ${({ isDesktop }) => isDesktop && '100%'};
`;

const ErrorMsg = styled.div`
  max-width: ${({ isDesktop }) => (isDesktop ? '380px' : '290px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Hind';
  font-style: normal;
  white-space: normal;
  text-align: center;
`;
const Img = styled.div`
  background-image: ${() => {
    if (siteId === 'UBPE') return `url(${errorImageUB})`;
    return `url(${errorImage})`;
  }};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 275px;
  height: 146px;
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;
  margin-top: 32px;
`;

const Text = styled.p`
  max-width: 295px;
  height: 52px;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  margin-top: 8px;
`;

const CTA = styled.button`
  height: 40px;
  width: 111px;
  border-radius: 12px;
  color: white;
  background-color: ${getColor('primary')};
  font-weight: 600;
  font-size: 14px;
  line-height: 130%;
  text-align: center;
  cursor: pointer;
  margin-top: 16px;
`;

function ErrorScreen({ isDesktop, handleOnclick }) {
  const { t } = useTranslation();
  return (
    <Wrapper isDesktop={isDesktop}>
      <Img />
      <ErrorMsg isDesktop={isDesktop}>
        <Title>{t('panel.errorScreen.title')}</Title>
        <Text>{t('panel.errorScreen.text')}</Text>
        <CTA onClick={() => handleOnclick()}>{t('panel.errorScreen.cta')}</CTA>
      </ErrorMsg>
    </Wrapper>
  );
}

export default ErrorScreen;
